<template>
  <div>
    <base-header class="pb-6" type>
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">Dashboard</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <ol class="breadcrumb breadcrumb-links">
              <li class="breadcrumb-item">
                <router-link to="/">
                  <i class="fas fa-home" />
                </router-link>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Dashboards</a>
              </li>
            </ol>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      <!-- first row cards -->
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-blue border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Customers
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{
                    customerCount
                  }}</span>
                  <base-progress
                    :value="30"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <router-link
                  to="/customers"
                  class="text-nowrap text-white font-weight-600"
                  >See details</router-link
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-green border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Monthly Sales
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{
                    saleCount
                  }}</span>
                  <base-progress
                    :value="50"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <router-link
                  to="/sales/list"
                  class="text-nowrap text-white font-weight-600"
                  >See details</router-link
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-danger border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Products
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{
                    productsCount
                  }}</span>
                  <base-progress
                    :value="80"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <router-link
                  to="products/list"
                  class="text-nowrap text-white font-weight-600"
                  >See details</router-link
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-default border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Monthly Expenses
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">
                    <i class="fas fa-rupee-sign" />
                    {{ monthlyExpense }}
                  </span>
                  <base-progress
                    :value="90"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <router-link
                  to="expenses/list"
                  class="text-nowrap text-white font-weight-600"
                  >See details</router-link
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- second row cards  -->
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-orange border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Pending Quotations
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{
                    pendingQuotationCount
                  }}</span>
                  <base-progress
                    :value="30"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <a
                  class="text-nowrap text-white font-weight-600"
                  @click="goToQuotations()"
                  >See Details</a
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-info border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Today's Service Requests
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{
                    serviceRequestCount
                  }}</span>
                  <base-progress
                    :value="50"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <router-link
                  to="/serviceRequests/list"
                  class="text-nowrap text-white font-weight-600"
                  >See details</router-link
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-yellow border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Products
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{
                    productsCount
                  }}</span>
                  <base-progress
                    :value="80"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <router-link
                  to="products/list"
                  class="text-nowrap text-white font-weight-600"
                  >See details</router-link
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-pink border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5
                    class="card-title text-uppercase text-muted mb-0 text-white"
                  >
                    Expenses
                  </h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{
                    expenses.length
                  }}</span>
                  <base-progress
                    :value="90"
                    class="progress-xs mt-3 mb-0"
                    type="success"
                  />
                </div>
                <div class="col-auto">
                  <base-dropdown
                    :has-toggle="false"
                    title-classes="btn btn-sm btn-neutral mr-0"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-h" />
                    </template>

                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </base-dropdown>
                </div>
              </div>
              <p class="mt-3 mb-0 text-sm">
                <router-link
                  to="expenses/list"
                  class="text-nowrap text-white font-weight-600"
                  >See details</router-link
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="card-deck flex-column">
        <!-- category wise distributed service requests -->
        <card class="col-md-12" header-classes="bg-transparent">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h6 class="text-uppercase text-muted ls-1 mb-1">
                Categorization
              </h6>
              <h5 class="h3 mb-0">Service Requests</h5>
            </div>
            <div class="col">
              <div
                v-if="selectedPeriodForCategorisedRequests === 'weekly'"
                class="action-buttons"
              >
                <base-button
                  size="sm"
                  type="primary"
                  @click="getPreviousCategorisedData()"
                  >Prev</base-button
                >
                <base-button
                  :disabled="showCategorisedNext"
                  size="sm"
                  type="primary"
                  @click="getNextCategorisedData()"
                  >Next</base-button
                >
              </div>
            </div>
            <div class="col">
              <base-input label="Select Period">
                <el-select
                  v-model="selectedPeriodForCategorisedRequests"
                  @change="getChartDataForSelectedPeriod"
                >
                  <el-option
                    v-for="(item, index) in periodOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  />
                </el-select>
              </base-input>
              <span v-if="selectedPeriodForCategorisedRequests === 'weekly'">
                This Week's Total - {{ categorisedWeeklyTotalCount }}
              </span>
            </div>
          </div>

          <stacked-chart
            v-if="
              categoriedChartLoader === false &&
                categorisedData.chartData.datasets &&
                categorisedData.chartData.datasets.length > 1
            "
            ref="stackedChart"
            :height="350"
            :chart-data="categorisedData.chartData"
          />
          <i v-else class="fas fa-spinner fa-spin" />
        </card>
        <!-- open and closed service requests count -->
        <card class="col-md-12" header-classes="bg-transparent">
          <div slot="header" class="row align-items-center">
            <div class="flex">
              <h6 class="text-uppercase text-muted ls-1 mb-1">
                Registered & Closed
              </h6>
              <h5 class="h3 mb-0">Service Requests</h5>
            </div>
            <div class="col action-buttons">
              <span class="selected-year">
                {{ this.selectedYear }}
              </span>
              <div>
                <base-button
                  size="sm"
                  type="primary"
                  @click="getPreviousOpenCloseData()"
                  >Prev</base-button
                >
                <base-button
                  size="sm"
                  type="primary"
                  @click="getNextOpenCloseData()"
                  >Next</base-button
                >
              </div>
            </div>
            <div class="flex">
              <base-input label="Select Period">
                <el-select
                  v-model="selectedPeriodForOpenCloseRequests"
                  @change="getOpenCloseDataForSelectedPeriod"
                >
                  <el-option
                    v-for="(item, index) in periodOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  />
                </el-select>
              </base-input>
              <div
                class=""
                v-if="selectedPeriodForOpenCloseRequests === 'weekly'"
              >
                <span>
                  This Week's Total Closed - {{ openCloseWeeklyClosedCount }}
                </span>
                <br />
                <span>
                  This Week's Total Registered -
                  {{ openCloseWeeklyRegisteredCount }}
                </span>
              </div>
            </div>
          </div>

          <open-close-bar-chart
            v-if="
              openCloseChartLoader === false &&
                openCloseBarData.chartData.datasets &&
                openCloseBarData.chartData.datasets.length > 1
            "
            ref="openCloseBarChart"
            :height="350"
            :chart-data="openCloseBarData.chartData"
          />
          <i v-else class="fas fa-spinner fa-spin" />
        </card>

        <div class="row">
        <!-- monthly vendors average points -->

          <card class="col-md-6" header-classes="bg-transparent">
          <div slot="header" class="row align-items-center justify-content">
            <div class="flex">
              <h6 class="text-uppercase text-muted ls-1 mb-1">
                Monthly Vendor's
              </h6>
              <h5 class="h3 mb-0">Average Points</h5>
            </div>
            <div>
              <div class="">
                <base-input label="Selected Month">
                  <el-date-picker
                    v-model="selectedMonthForAveragePoints"
                    type="month"
                    format="MMM yyyy"
                    placeholder="Pick a month"
                    @change="getMonthlyAveragePointOfVendors()"
                  >
                  </el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <el-table
            :data="monthlyAverageData"
            style="width: 100%"
            border
            header-row-class-name="thead-light"
          >
            <el-table-column label="Name" prop="name"></el-table-column>
            <el-table-column label="Count" prop="count"></el-table-column>
            <el-table-column
              label="Average Points"
              prop="average"
            ></el-table-column>
          </el-table>
        </card>
          <!-- Vendor's Points and Penalties (monthwise from vendor_points) -->
          <card class="col-md-6" header-classes="bg-transparent">
          <div slot="header" class="row align-items-center justify-content">
            <div class="flex">
              <h6 class="text-uppercase text-muted ls-1 mb-1">
                Vendor's Points and Penalties
              </h6>
              <h5 class="h3 mb-0">Monthwise</h5>
            </div>
            <div>
              <div class="">
                <base-input label="Selected Month">
                  <el-date-picker
                    v-model="selectedMonthForPointsAndPenalties"
                    type="month"
                    format="MMM yyyy"
                    placeholder="Pick a month"
                    @change="getMonthlyVendorPointsAndPenalties()"
                  >
                  </el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <el-table
            :data="monthlyPointsAndPenaltiesData"
            style="width: 100%"
            border
            header-row-class-name="thead-light"
          >
            <el-table-column label="Vendor" prop="vendor"></el-table-column>
            <el-table-column label="Points" prop="points"></el-table-column>
            <el-table-column label="Penalties" prop="penalties"></el-table-column>
          </el-table>
        </card>
        </div>

      

      
      </div>
    </div>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import StackedChart from "@/components/Charts/StackedChart";
import openCloseBarChart from "@/components/Charts/OpenCloseServiceRequestChart";
// Components
import BaseHeader from "@/components/BaseHeader";
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";

// Lists
import TaskList from "@/views/Widgets/TaskList";
import { mapGetters, mapActions } from "vuex";
import dateFns from "date-fns";
import { Select, Option, Table, TableColumn, DatePicker } from "element-ui";
export default {
  components: {
    LineChart,
    BarChart,
    BaseHeader,
    BaseProgress,
    RouteBreadCrumb,
    StatsCard,
    TaskList,
    StackedChart,
    openCloseBarChart,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      categoriedChartLoader: false,
      openCloseChartLoader: false,
      categorisedData: {
        chartData: {},
        extraOptions: chartConfigs.blueChartOptions
      },
      openCloseBarData: {
        chartData: {},
        extraOptions: chartConfigs.blueChartOptions
      },
      periodOptions: [
        {
          label: "Daily",
          value: "weekly"
        },
        {
          label: "Monthly",
          value: "monthly"
        }
      ],
      selectedPeriodForCategorisedRequests: "weekly",
      selectedPeriodForOpenCloseRequests: "weekly",
      startOfWeek: null, //categorised chart
      endOfWeek: null, //categorised chart
      currentYear: dateFns.getYear(new Date()), //categorised chart
      weekStart: null, //open close chart
      weekEnd: null, //open close chart
      selectedYear: dateFns.getYear(new Date()), //open close chart
      categorisedWeeklyTotalCount: 0,
      openCloseWeeklyClosedCount: 0,
      openCloseWeeklyRegisteredCount: 0,
      monthlyAverageData: [],
      selectedMonthForAveragePoints: new Date(),
      monthlyPointsAndPenaltiesData: [],
      selectedMonthForPointsAndPenalties: new Date()
    };
  },

  computed: {
    ...mapGetters({
      customers: "user/getCustomerList",
      sales: "sale/getSaleList",
      products: "product/getProducts",
      expenses: "expense/getExpenseList",
      pendingQuotations: "serviceRequestQuotation/getQuotationMeta",
      monthlyExpense: "expense/getMonthlyExpenseAmount",
      serviceRequests: "serviceRequest/getServiceRequestList"
    }),
    customerCount() {
      return this.customers && this.customers.meta && this.customers.meta.total
        ? this.customers.meta.total
        : 0;
    },
    saleCount() {
      return this.sales && this.sales.meta && this.sales.meta.total
        ? this.sales.meta.total
        : 0;
    },
    productsCount() {
      return this.products && this.products.meta && this.products.meta.total
        ? this.products.meta.total
        : 0;
    },
    pendingQuotationCount() {
      return this.pendingQuotations && this.pendingQuotations.total
        ? this.pendingQuotations.total
        : 0;
    },
    serviceRequestCount() {
      return this.serviceRequests &&
        this.serviceRequests.meta &&
        this.serviceRequests.meta.total
        ? this.serviceRequests.meta.total
        : 0;
    },
    showCategorisedNext() {
      let result = dateFns.isAfter(new Date(this.endOfWeek), new Date());
      if (result === false) {
        result = dateFns.isSameDay(new Date(this.endOfWeek), new Date());
      }
      return result;
    },
    showOpenCloseNext() {
      let result = dateFns.isAfter(new Date(this.weekEnd), new Date());
      if (result === false) {
        result = dateFns.isSameDay(new Date(this.weekEnd), new Date());
      }
      return result;
    }
  },
  mounted() {
    this.currentYear = dateFns.getYear(new Date());
    this.getWeeklyCategorisedChartData();
    this.getWeeklyOpenCloseChartData();
    this.getMonthlyAveragePointOfVendors();
    this.getMonthlyVendorPointsAndPenalties();
    this.getUsers({ role: "Customer" });
    this.getSales();
    this.getProducts();
    this.getMonthlyExpenseTotal({
      date: `${dateFns.format(new Date(), "YYYY-MM-DD")}`
    });
    this.getQuotations({ status: "pending" });
    this.getServiceRequests({
      fromDate: dateFns.format(new Date(), "YYYY-MM-DD"),
      toDate: dateFns.format(dateFns.startOfTomorrow(), "YYYY-MM-DD")
    });
  },

  methods: {
    ...mapActions({
      getUsers: "user/getUsers",
      getSales: "sale/getSales",
      getProducts: "product/getProducts",
      getMonthlyExpenseTotal: "expense/getMonthlyExpenseTotal",
      getQuotations: "serviceRequestQuotation/getQuotations",
      getServiceRequests: "serviceRequest/getServiceRequestList",
      getCategoriesedData: "serviceRequest/getStackedChartDataOfServiceRequest",
      getOpenCloseServiceRequestData:
        "serviceRequest/getOpenCloseServiceRequestData",
      getAveragePoints: "vendor/getMonthlyAveragePointsOfVendor",
      getMonthwiseVendorPointsAndPenalties:
        "vendor/getMonthwiseVendorPointsAndPenalties"
    }),

    getMonthlyAveragePointOfVendors() {
      const date = dateFns.format(
        new Date(this.selectedMonthForAveragePoints),
        "YYYY-MM-DD"
      );
      this.getAveragePoints(date).then(res => {
        this.monthlyAverageData = res.data;
      });
    },
    getMonthlyVendorPointsAndPenalties() {
      const month = dateFns.format(
        new Date(this.selectedMonthForPointsAndPenalties),
        "YYYY-MM"
      );
      this.getMonthwiseVendorPointsAndPenalties(month).then(res => {
        this.monthlyPointsAndPenaltiesData = res.data || [];
      });
    },
    async goToQuotations() {
      await this.getQuotations({ status: "pending" });
      this.$router.push("/quotation/list");
    },

    //categorised service requests chart functions
    getChartDataForSelectedPeriod(value) {
      if (value === "weekly") {
        this.getWeeklyCategorisedChartData();
      } else {
        this.getMonthlyCategorisedChartData();
      }
    },
    getWeeklyCategorisedChartData() {
      this.startOfWeek = dateFns.subDays(new Date(), 6);
      this.endOfWeek = new Date();
      this.getCategorisedChartDataForSelectedPeriod({
        startDate: this.startOfWeek,
        endDate: this.endOfWeek
      });
    },
    getMonthlyCategorisedChartData() {
      this.currentYear = dateFns.getYear(new Date());
      this.getCategorisedChartDataForSelectedPeriod({
        year: this.currentYear
      });
    },
    getCategorisedChartDataForSelectedPeriod(data) {
      let query = {};
      if (this.selectedPeriodForCategorisedRequests === "weekly") {
        query = {
          startDate: dateFns.format(data.startDate, "YYYY-MM-DD"),
          endDate: dateFns.format(data.endDate, "YYYY-MM-DD"),
          period: this.selectedPeriodForCategorisedRequests
        };
      } else {
        query = {
          year: data.year,
          period: this.selectedPeriodForCategorisedRequests
        };
      }
      this.getCategoriesedData(query).then(response => {
        this.categoriedChartLoader = true;
        this.categorisedData.chartData = JSON.parse(
          JSON.stringify({
            datasets: response.data.datasets,
            labels: response.data.labels
          })
        );
        this.categorisedWeeklyTotalCount = response.data.weeklyTotalCount;
        this.categoriedChartLoader = false;
      });
    },
    getPreviousCategorisedData() {
      if (this.selectedPeriodForCategorisedRequests === "weekly") {
        this.endOfWeek = this.startOfWeek;
        this.startOfWeek = dateFns.subDays(this.endOfWeek, 6);
        this.getCategorisedChartDataForSelectedPeriod({
          startDate: this.startOfWeek,
          endDate: this.endOfWeek
        });
      }
    },
    getNextCategorisedData() {
      if (this.selectedPeriodForCategorisedRequests === "weekly") {
        this.startOfWeek = this.endOfWeek;
        this.endOfWeek = dateFns.addDays(this.startOfWeek, 6);
        this.getCategorisedChartDataForSelectedPeriod({
          startDate: this.startOfWeek,
          endDate: this.endOfWeek
        });
      }
    },

    // open-closed service request chart functions
    getOpenCloseDataForSelectedPeriod(value) {
      this.selectedYear = this.currentYear;
      if (value === "weekly") {
        this.getWeeklyOpenCloseChartData();
      } else {
        this.getMonthlyOpenCloseChartData();
      }
    },
    getWeeklyOpenCloseChartData() {
      this.weekStart = dateFns.subDays(new Date(), 6);
      this.weekEnd = new Date();
      this.getOpenCloseChartDataForSelectedPeriod({
        startDate: this.weekStart,
        endDate: this.weekEnd
      });
    },
    getMonthlyOpenCloseChartData() {
      this.selectedYear = dateFns.getYear(new Date());
      this.getOpenCloseChartDataForSelectedPeriod({
        year: this.selectedYear
      });
    },
    getOpenCloseChartDataForSelectedPeriod(data) {
      let query = {};
      if (this.selectedPeriodForOpenCloseRequests === "weekly") {
        this.selectedYear = dateFns.getYear(new Date(data.endDate));

        query = {
          startDate: dateFns.format(data.startDate, "YYYY-MM-DD"),
          endDate: dateFns.format(data.endDate, "YYYY-MM-DD"),
          period: this.selectedPeriodForOpenCloseRequests
        };
      } else {
        query = {
          year: data.year,
          period: this.selectedPeriodForOpenCloseRequests
        };
      }
      this.getOpenCloseServiceRequestData(query).then(response => {
        this.openCloseChartLoader = true;
        this.openCloseBarData.chartData = JSON.parse(
          JSON.stringify({
            datasets: response.data.datasets,
            labels: response.data.labels
          })
        );
        this.openCloseWeeklyClosedCount = response.data.weeklyClosedCount;
        this.openCloseWeeklyRegisteredCount =
          response.data.weeklyRegisteredCount;
        this.openCloseChartLoader = false;
      });
    },
    getPreviousOpenCloseData() {
      if (this.selectedPeriodForOpenCloseRequests === "weekly") {
        this.weekEnd = this.weekStart;
        this.weekStart = dateFns.subDays(this.weekEnd, 6);
        this.getOpenCloseChartDataForSelectedPeriod({
          startDate: this.weekStart,
          endDate: this.weekEnd
        });
      } else if (this.selectedPeriodForOpenCloseRequests === "monthly") {
        this.selectedYear = this.selectedYear - 1;
        this.getOpenCloseChartDataForSelectedPeriod({
          year: this.selectedYear
        });
      }
    },
    getNextOpenCloseData() {
      if (this.selectedPeriodForOpenCloseRequests === "weekly") {
        this.weekStart = this.weekEnd;
        this.weekEnd = dateFns.addDays(this.weekStart, 6);
        this.getOpenCloseChartDataForSelectedPeriod({
          startDate: this.weekStart,
          endDate: this.weekEnd
        });
      } else if (this.selectedPeriodForOpenCloseRequests === "monthly") {
        if (this.currentYear >= this.selectedYear + 1) {
          this.selectedYear = this.selectedYear + 1;
          this.getOpenCloseChartDataForSelectedPeriod({
            year: this.selectedYear
          });
        }
      }
    }
  }
};
</script>
<style>
.action-buttons {
  text-align: center;
}
.selected-year {
  font-size: 24px;
  font-weight: 600;
}
.justify-content {
  justify-content: space-between;
}
</style>
